import React from "react";
import { Navigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({
  children,
  allowedRoles,
  requiredPerm,
}) {
  const { user, loading, can } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
          bgcolor: "background.default",
        }}
      >
        <CircularProgress />
        <Typography variant="body2" color="text.secondary">
          Loading your workspace…
        </Typography>
      </Box>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Permission-based guard (preferred)
  if (requiredPerm && !can(requiredPerm)) {
    return <Navigate to="/" replace />;
  }

  // Legacy role-based guard (fallback for routes not yet migrated)
  if (
    !requiredPerm &&
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.includes(user.role)
  ) {
    return <Navigate to="/" replace />;
  }

  return children;
}
